<template>
  <div ref="chart" class="brain-chart"></div>
</template>

<script>
import * as echarts from "echarts";
import "echarts-wordcloud";

const PALETTE = ["#ff4fa3", "#7b5cff", "#00c2a8", "#ffb020", "#3aa0ff", "#ff6b6b", "#a0e426", "#e879f9"];

// 🧠 실루엣 마스크 워드클라우드 (순수 뷰). words(문자열 배열)만 넣으면 뇌 모양에 채워진다.
export default {
  name: "BrainWordCloud",
  props: {
    // 문자열 배열(크기 랜덤) 또는 { word|name, weight|value } 배열(weight로 크기).
    words: { type: Array, default: () => [] },
  },
  watch: {
    words: {
      deep: true,
      handler() {
        this.render();
      },
    },
  },
  async mounted() {
    this._mask = await this.makeBrainMask();
    this._chart = echarts.init(this.$refs.chart);
    window.addEventListener("resize", this._onResize);
    this.render();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this._onResize);
    if (this._chart) this._chart.dispose();
  },
  methods: {
    reshuffle() {
      this.render(); // 같은 단어, 색/크기/배치만 랜덤 재생성
    },
    // 입력 아이템 → echarts { name, value }. weight 있으면 크기 반영, 없으면 랜덤.
    _toDatum(w) {
      const rand = 12 + Math.floor(Math.random() * 60);
      if (typeof w === "string") return { name: w, value: rand };
      const name = w.word || w.name || "";
      const weight = w.weight != null ? w.weight : w.value;
      return { name, value: weight != null ? weight : rand };
    },
    _onResize() {
      if (this._chart) this._chart.resize();
    },
    // 🧠 이모지를 그려 실루엣(검정) 마스크로 → 단어가 이 영역만 채움
    makeBrainMask() {
      return new Promise((resolve) => {
        const size = 512;
        const c = document.createElement("canvas");
        c.width = size;
        c.height = size;
        const ctx = c.getContext("2d");
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.font = `${Math.floor(size * 0.82)}px serif`;
        ctx.fillText("🧠", size / 2, size * 0.54);
        ctx.globalCompositeOperation = "source-in";
        ctx.fillStyle = "#000";
        ctx.fillRect(0, 0, size, size);
        const img = new Image();
        img.onload = () => resolve(img);
        img.src = c.toDataURL();
      });
    },
    render() {
      if (!this._chart || !this._mask) return;
      const data = (this.words || []).map((w) => this._toDatum(w));
      this._chart.setOption(
        {
          tooltip: { show: false },
          series: [
            {
              type: "wordCloud",
              maskImage: this._mask,
              left: "center",
              top: "center",
              width: "100%",
              height: "100%",
              right: null,
              bottom: null,
              sizeRange: [14, 74],
              rotationRange: [-30, 30],
              rotationStep: 15,
              gridSize: 6,
              drawOutOfBound: false,
              shrinkToFit: true,
              layoutAnimation: true,
              textStyle: {
                fontFamily: "maplestory, sans-serif",
                fontWeight: "bold",
                color: () => PALETTE[Math.floor(Math.random() * PALETTE.length)],
              },
              emphasis: { textStyle: { textShadowBlur: 8, textShadowColor: "#00000055" } },
              data,
            },
          ],
        },
        true,
      );
    },
  },
};
</script>

<style scoped>
.brain-chart {
  width: 100%;
  max-width: 640px;
  height: 560px;
}
</style>
